var _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_note_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.642,
    height: 68.651,
    viewBox: "0 0 60.642 68.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104903",
    "data-name": "Trazado 104903",
    d: "M7165.756,1774.622l-1.9-2.586-3.293,2.586,3.293,2.359Z",
    transform: "translate(-7105.908 -1744.062)",
    fill: "#1aa8a2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104899",
    "data-name": "Trazado 104899",
    d: "M7156.062,1749.275h8.665V1803.1h-43.333v-5h33.028l6.482-10.4-.646-34.049Z",
    transform: "translate(-7114.506 -1744.346)",
    fill: "#fce3ed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104902",
    "data-name": "Trazado 104902",
    d: "M7151.1,1794.405l11.938-20.126,4.263,2.546-16.2,27.417-4.387-2.974Z",
    transform: "translate(-7110.636 -1740.523)",
    fill: "#ee2b7c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104900",
    "data-name": "Trazado 104900",
    d: "M7119.328,1798.746H7155.1l6.023-10.332v-34.44l-9.164-8.084h-32.634Z",
    transform: "translate(-7114.822 -1744.864)",
    fill: "#b1e0de"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104901",
    "data-name": "Trazado 104901",
    d: "M7148.348,1753.8h7.134l-7.134-7.45Z",
    transform: "translate(-7110.385 -1744.793)",
    fill: "#1aa8a2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76220",
    "data-name": "Trazado 76220",
    d: "M129.144,106.288h25.172a1.144,1.144,0,1,0,0-2.288H129.144a1.144,1.144,0,1,0,0,2.288Z",
    transform: "translate(-115.412 -91.414)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76221",
    "data-name": "Trazado 76221",
    d: "M129.144,154.288h25.172a1.144,1.144,0,1,0,0-2.288H129.144a1.144,1.144,0,1,0,0,2.288Z",
    transform: "translate(-115.412 -132.549)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76222",
    "data-name": "Trazado 76222",
    d: "M129.144,202.288h25.172a1.144,1.144,0,0,0,0-2.288H129.144a1.144,1.144,0,0,0,0,2.288Z",
    transform: "translate(-115.412 -173.684)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76223",
    "data-name": "Trazado 76223",
    d: "M129.144,250.288h25.172a1.144,1.144,0,0,0,0-2.288H129.144a1.144,1.144,0,0,0,0,2.288Z",
    transform: "translate(-115.412 -214.819)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76224",
    "data-name": "Trazado 76224",
    d: "M129.144,298.288H138.3a1.144,1.144,0,1,0,0-2.288h-9.153a1.144,1.144,0,1,0,0,2.288Z",
    transform: "translate(-115.412 -255.954)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76225",
    "data-name": "Trazado 76225",
    d: "M98.934,43.033a3.436,3.436,0,0,0-4.7,1.226l-2.759,4.707V20.577a1.144,1.144,0,0,0-1.144-1.144H81.654a44.864,44.864,0,0,0-3.576-3.383A1.141,1.141,0,0,0,77.748,16H44.566a1.144,1.144,0,0,0-1.144,1.144v3.577a4.577,4.577,0,0,0,0,8.864v2.578a4.577,4.577,0,0,0,0,8.864v2.578a4.577,4.577,0,0,0,0,8.864V53.9a4.577,4.577,0,0,0,0,8.864v7.01a1.144,1.144,0,0,0,1.144,1.144H45.71v3.433A1.144,1.144,0,0,0,46.855,75.5H75.93l-.784,1.338a1.135,1.135,0,0,0-.14.389c0,.007,0,.012,0,.019l0,.019v0l-.915,6.07a1.144,1.144,0,0,0,1.833,1.074l4.867-3.779c.312-.242.464-.39.44-.589L83.887,75.5h6.447a1.144,1.144,0,0,0,1.144-1.144V62.545l8.681-14.815a3.436,3.436,0,0,0-1.225-4.7Zm-2.024,1.854a1.144,1.144,0,0,1,1.276,1.686l-.579.987L95.633,46.4l.579-.987a1.136,1.136,0,0,1,.7-.529ZM79.673,78.162,77.7,77.005,92.74,51.339,94.714,52.5Zm-.781-58.256,4.1,4.1h-4.1ZM93.9,49.365l.578-.987,1.974,1.157-.579.987ZM89.189,21.721V52.614a1.15,1.15,0,0,0,.022.221L86.9,56.777V25.153a1.141,1.141,0,0,0-.334-.808h0l-2.623-2.623ZM45.71,18.288H76.6v6.865A1.144,1.144,0,0,0,77.748,26.3h6.865V60.682l-4.659,7.951H45.71V62.767A4.573,4.573,0,0,0,49,59.478a1.145,1.145,0,1,0-2.217-.57,2.281,2.281,0,0,1-1.071,1.408V52.469A4.573,4.573,0,0,0,49,49.18a1.145,1.145,0,1,0-2.217-.57,2.281,2.281,0,0,1-1.071,1.408V41.027A4.573,4.573,0,0,0,49,37.739a1.145,1.145,0,0,0-2.217-.57,2.281,2.281,0,0,1-1.071,1.408V29.585A4.573,4.573,0,0,0,49,26.3a1.145,1.145,0,1,0-2.217-.57,2.281,2.281,0,0,1-1.071,1.408Zm-3.433,6.865a2.288,2.288,0,0,1,1.144-1.979v3.957A2.288,2.288,0,0,1,42.278,25.153Zm0,11.442a2.288,2.288,0,0,1,1.144-1.979v3.957A2.288,2.288,0,0,1,42.278,36.6Zm0,11.442a2.288,2.288,0,0,1,1.144-1.979v3.957A2.288,2.288,0,0,1,42.278,48.037Zm0,10.3a2.288,2.288,0,0,1,1.144-1.979v3.957A2.288,2.288,0,0,1,42.278,58.335ZM48,73.209V70.921H78.612l-1.341,2.288Zm29.014,6.046,1.032.605-1.273.988Zm12.177-6.046H85.228l3.962-6.759Z",
    transform: "translate(-39.988 -16)",
    fill: "#3b0310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducacion);
export default __webpack_public_path__ + "static/media/educacion.6822acd018cd73ffa2403e518899b469.svg";
export { ForwardRef as ReactComponent };